namespace Matrix.Rebalancer {
    export namespace HoldingClassWeightService {
        export const baseUrl = 'Rebalancer/HoldingClassWeight';

        export declare function Create(request: Serenity.SaveRequest<HoldingClassWeightRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<HoldingClassWeightRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<HoldingClassWeightRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<HoldingClassWeightRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/HoldingClassWeight/Create",
            Update = "Rebalancer/HoldingClassWeight/Update",
            Delete = "Rebalancer/HoldingClassWeight/Delete",
            Retrieve = "Rebalancer/HoldingClassWeight/Retrieve",
            List = "Rebalancer/HoldingClassWeight/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>HoldingClassWeightService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
